<div class="feedback-form">
  <h1>Feedback</h1>
  <small> Please provide your feedback below</small>

  <mat-divider></mat-divider>

  <form [formGroup]="feedbackForm">
    <div class="d-flex flex-column flex-sm-row flex-wrap justify-center gap-4 p-4">
      <div class="smile-buttons">
        <div class="emotion-options" role="radiogroup" aria-label="Select feedback emotion">
          <button type="button" class="emotion-option sad" [class.active]="feedbackForm.get('emotion')?.value === 1"
            (click)="selectEmotion(1)" aria-pressed="false" matTooltip="Sad">
            <i class="far fa-frown" aria-hidden="true"></i>
          </button>
          <button type="button" class="emotion-option neutral" [class.active]="feedbackForm.get('emotion')?.value === 2"
            (click)="selectEmotion(2)" aria-pressed="false" matTooltip="Neutral">
            <i class="far fa-meh" aria-hidden="true"></i>
          </button>
          <button type="button" class="emotion-option happy" [class.active]="feedbackForm.get('emotion')?.value === 3"
            (click)="selectEmotion(3)" aria-pressed="false" matTooltip="Happy">
            <i class="far fa-grin-beam" aria-hidden="true"></i>
          </button>
          <button type="button" class="emotion-option great" [class.active]="feedbackForm.get('emotion')?.value === 4"
            (click)="selectEmotion(4)" aria-pressed="false" matTooltip="Great">
            <i class="far fa-grin-hearts" aria-hidden="true"></i>
          </button>
        </div>
      </div>

    </div>
    <div class="comments-box">
      <mat-form-field class="full-width">
        <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="2" cdkAutosizeMaxRows="5" formControlName="message" placeholder="How can we make this page better?"></textarea>
        <mat-error *ngIf="getControlErrors('message', 'required')"> Message is
          <strong>required</strong><br/>
        </mat-error>
        <mat-error *ngIf="getControlErrors('message', 'minlength')"> Message
          <strong>min length(25 char)</strong>
        </mat-error>
      </mat-form-field>
    </div>

    <div class="actions">
      <button mat-stroked-button (click)="onDismiss()">Cancel</button>
      <button type="submit" mat-flat-button [disabled]="feedbackForm.invalid" color="primary"
        (click)="onConfirm(feedbackForm.value)">
        Send
      </button>
    </div>


  </form>
</div>